export default __webpack_public_path__ + "static/media/wing.1a694d38.png";